export enum ImageType {
  ICON = 'icon',
  EMOJI = 'emoji',
  URL = 'url',
}
export interface ImageTabs {
  type: ImageType;
  active: boolean;
  name: string;
}

export interface UploadSettings {
  workspaceId: string;
  target: string;
  targetId: string;
  groupId: string;
  sessionId: string | null;
}
